import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { returnToCart } from 'bento-ordering/menus/actions/menuItem';
import { getMenuItem } from 'bento-ordering/menus/reducers/menuItemsDetail';

import MenuUpsellItemDescription from 'bento-ordering/cart/containers/MenuUpsellItemDescription';
import Modal from 'bento-ordering/base/ui_components/Modal';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

const MenuUpsellItemDescriptionModal = ({ match, menuItem }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      onClose={() => dispatch(returnToCart())}
      ariaLabel={`Add upsell item form dialog for ${menuItem.name} Item`}
    >
      <MenuUpsellItemDescription match={match} />
    </Modal>
  );
};

MenuUpsellItemDescriptionModal.propTypes = {
  match: PropTypes.object.isRequired,
  menuItem: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const menuItemSlug = ownProps.match.params.menuItemSlug;
  const menuItem = getMenuItem(state, menuItemSlug);

  return {
    match: ownProps.match,
    menuItem: menuItem
  };
};

export default withRouter(
  withGoogleLibraryLoaded(
    connect(mapStateToProps)(MenuUpsellItemDescriptionModal)
  )
);
